// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Alfa+Slab+One&family=Bitter:wght@400;700;900&family=Crimson+Pro:wght@700;900&family=Noto+Serif:wght@900&family=Roboto:wght@400;500;700;900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.exchangeMain {
  background-color: #07405E;
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 100%;
  height: 100dvh;
}
.exchangeMain .exchangeContainer {
  display: flex;
  align-items: center;
  flex-direction: column;
  overflow-x: hidden;
  overflow-y: auto;
  width: 100%;
  height: 100dvh;
  padding: 10px 0px;
}
@media (min-width: 450px) {
  .exchangeMain .exchangeContainer {
    width: 400px;
  }
}
@media only screen and (max-height: 712px) {
  .exchangeMain .exchangeContainer {
    height: 100%;
  }
}
.exchangeMain .exchangeContainer .exchangeDiamond {
  width: 50%;
  min-height: 150px;
  opacity: 1;
  background-position: center;
  background-repeat: no-repeat;
}
@media only screen and (max-height: 712px) {
  .exchangeMain .exchangeContainer .exchangeDiamond {
    width: 40%;
    min-height: 110px;
  }
}
.exchangeMain .exchangeContainer .divider::before {
  background-color: #699BB6;
}
.exchangeMain .exchangeContainer .divider::after {
  background-color: #699BB6;
}
.exchangeMain .exchangeContainer .exchangeIcon {
  filter: brightness(0) saturate(100%) invert(59%) sepia(10%) saturate(1390%) hue-rotate(157deg) brightness(96%) contrast(87%);
}
.exchangeMain .exchangeContainer .selectText {
  margin-top: 10px;
  max-width: 320px;
  text-align: center;
  font-size: 17px;
  color: #699BB6;
  font-family: "Roboto", sans-serif;
  padding: 16px;
}
.exchangeMain .exchangeContainer .selectedCards {
  display: flex;
  gap: 10px;
  min-height: 105px;
}
.exchangeMain .exchangeContainer .selectCardsContainer, .exchangeMain .exchangeContainer .selectedCardsContainer {
  width: 400px;
  margin: 0 auto;
  overflow-x: auto;
  white-space: nowrap;
}
.exchangeMain .exchangeContainer .selectCardsContainer .selectCardsWrapper, .exchangeMain .exchangeContainer .selectCardsContainer .selectedCardsWrapper, .exchangeMain .exchangeContainer .selectedCardsContainer .selectCardsWrapper, .exchangeMain .exchangeContainer .selectedCardsContainer .selectedCardsWrapper {
  display: flex;
  gap: 10px;
  width: 400px;
  justify-content: flex-start;
}
.exchangeMain .exchangeContainer .selectedCardsContainer {
  min-height: 105px;
  overflow-y: hidden;
}
.exchangeMain .exchangeContainer .selectCardsContainer {
  min-height: 140px;
}`, "",{"version":3,"sources":["webpack://./src/modules/diamonds/diamondsList/diamondScreen/exchange/index.scss","webpack://./src/scss/colors.scss","webpack://./src/scss/fonts.scss"],"names":[],"mappings":"AAEA;EACI,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,WAAA;EACA,cAAA;AAAJ;AACI;EAOI,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EAEA,WAAA;EACA,cAAA;EACA,iBAAA;AANR;AARQ;EADJ;IAEQ,YAAA;EAWV;AACF;AAVQ;EAJJ;IAKQ,YAAA;EAaV;AACF;AAHQ;EACI,UAAA;EACA,iBAAA;EAKA,UAAA;EACA,2BAAA;EACA,4BAAA;AACZ;AAPY;EAHJ;IAIQ,UAAA;IACA,iBAAA;EAUd;AACF;AAJQ;EACI,yBCrCK;AD2CjB;AAJQ;EACI,yBCxCK;AD8CjB;AAJQ;EACI,4HAAA;AAMZ;AAJQ;EACI,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,cClDK;EDmDL,iCE/CH;EFgDG,aAAA;AAMZ;AAJQ;EACI,aAAA;EACA,SAAA;EACA,iBAAA;AAMZ;AAHQ;EACI,YAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;AAKZ;AAJY;EACI,aAAA;EACA,SAAA;EACA,YAAA;EACA,2BAAA;AAMhB;AAHQ;EACI,iBAAA;EACA,kBAAA;AAKZ;AAFQ;EACI,iBAAA;AAIZ","sourcesContent":["@import '../../../../../scss/colors.scss';\n@import '../../../../../scss/fonts.scss';\n.exchangeMain {\n    background-color: #07405E;\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    width: 100%;\n    height: 100dvh;\n    .exchangeContainer{\n        @media (min-width: 450px){\n            width: 400px;\n        }\n        @media only screen and (max-height: 712px) {\n            height: 100%;\n        }\n        display: flex;\n        align-items: center;\n        flex-direction: column;\n        overflow-x: hidden;\n        overflow-y: auto;\n\n        width: 100%;\n        height: 100dvh;\n        padding: 10px 0px;\n        .exchangeDiamond{\n            width: 50%;\n            min-height: 150px;\n            @media only screen and (max-height: 712px) {\n                width: 40%;\n                min-height: 110px;\n            }\n            opacity: 1;\n            background-position: center;\n            background-repeat: no-repeat;\n\n        }\n        .divider::before{\n            background-color: $color-Secondary;\n        }\n        .divider::after{\n            background-color: $color-Secondary;\n        }\n        .exchangeIcon{\n            filter: brightness(0) saturate(100%) invert(59%) sepia(10%) saturate(1390%) hue-rotate(157deg) brightness(96%) contrast(87%);                \n        }\n        .selectText{\n            margin-top: 10px;\n            max-width: 320px;\n            text-align: center;\n            font-size: 17px;\n            color: $color-Secondary;\n            font-family: $Roboto;\n            padding: 16px;\n        }\n        .selectedCards{\n            display: flex;\n            gap: 10px;\n            min-height: 105px;\n\n        }\n        .selectCardsContainer,.selectedCardsContainer{\n            width: 400px;\n            margin: 0 auto;\n            overflow-x: auto;\n            white-space:nowrap; \n            .selectCardsWrapper, .selectedCardsWrapper{\n                display: flex;\n                gap: 10px;\n                width: 400px;\n                justify-content: flex-start;\n            }\n        }\n        .selectedCardsContainer{\n            min-height: 105px;\n            overflow-y: hidden;\n            \n        }\n        .selectCardsContainer{\n            min-height: 140px;\n\n        }\n    }\n}\n","$color-White:#FFFFFF;\n$color-Secondary:#699BB6;\n\n$color-Gradient-1-2:#002F48;\n$color-Gradient-2-2:#FF6B6B;\n$color-Gradient-3-2:#987EE4;\n$color-Gradient-4-2:#F595DF; \n$color-Gradient-5-2:#FEA5A5;\n\n$color-Gradient-1-1:#216B93;\n$color-Gradient-2-1:#F595DF;\n$color-Gradient-3-1:#6D4ECB;\n$color-Gradient-4-1:#C465AE;\n\n","@import url('https://fonts.googleapis.com/css2?family=Alfa+Slab+One&family=Bitter:wght@400;700;900&family=Crimson+Pro:wght@700;900&family=Noto+Serif:wght@900&family=Roboto:wght@400;500;700;900&display=swap');\n$Bitter: 'Bitter', serif;   \n$Crimson-Pro: 'Crimson Pro', serif;\n$Alfa-Slab-One: 'Alfa Slab One', serif;\n$Noto-Serif: 'Noto Serif', serif;\n$Roboto: 'Roboto', sans-serif;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
